import { BaseApiService } from "../base/base-api.service";
import { LegalEntityBankAccountDTO, LegalEntityBankAccountSTO } from "../../models/legal-entity-bank-accounts";
import { ListSortDirection, Sort } from "../../models/api/sort";
import { toastifyResponse } from "../../utils/toastify-response/toastify-response";
import { LegalEntityBankAccountFilter } from "../../models/legal-entity-bank-accounts/legal-entity-bank-account-filter";

export class LegalEntityBankAccountsApiService extends BaseApiService<
  LegalEntityBankAccountDTO,
  LegalEntityBankAccountSTO
> {
  constructor() {
    super({
      servicePath: "/LegalEntityBankAccounts",
      loadItemsPath: "/GetLegalEntityBankAccounts",
      saveItemsPath: "/SaveLegalEntityBankAccounts",
    });
    this.defaultSort = [
      {
        name: "iban",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}

export const loadLegalEntityBankAccounts = async (id?: string) => {
  const response = await new LegalEntityBankAccountsApiService().loadItems({
    legalEntityIds: [id as string],
  } as LegalEntityBankAccountFilter);

  toastifyResponse(response, "failed");

  return response;
};

export const saveLegalEntityBankAccount = async (bankAccount: LegalEntityBankAccountSTO) => {
  const response = await new LegalEntityBankAccountsApiService().saveItems([bankAccount]);

  toastifyResponse(response, "all", "default_success_message", "failure_saving_data", "error_saving_data");

  return response;
};
